import Controller from "./booking.controller";
import template from "./booking.html";

const booking = {
  template,
  controller: Controller,
};

export default booking;



// WEBPACK FOOTER //
// ./src/pages/booking/booking.component.js